import React from "react";
import styled from "styled-components";
import { number } from "yup";

const Nav = styled.nav`
  .pagination{
    flex-direction: row;
    width: 30%;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }

  .active a{
    color: var(--color-accent-prim);
  }

  a {
    padding-left: 0;
    font-size: 1.2rem;
  }
`;

export const Pagination = ({ numberOfPages, currentPage, setCurrentPage }) => {
  const pageNumbers = [...Array(numberOfPages + 1).keys()].slice(1)    
  
  const nextPage = () => {
    if(currentPage !== numberOfPages) 
      setCurrentPage(currentPage + 1)
  }

  const prevPage = () => {
    if(currentPage !== 1) 
      setCurrentPage(currentPage - 1)
  }

  return (
          <Nav>
            { 
              numberOfPages > 1 && 
              <ul className='pagination'>
                  <li className="page-item">
                      <a className="page-link" 
                          onClick={prevPage} 
                          href='#'>                        
                          Previous
                      </a>
                  </li>
                  {/* Show all pages */}
                  {/* {pageNumbers.map(pgNumber => (
                      <li key={pgNumber} 
                          className= {`page-item ${currentPage == pgNumber ? 'active' : ''} `} >
                          <a onClick={() => setCurrentPage(pgNumber)}  
                              className='page-link' 
                              href='#'>                            
                              {pgNumber}
                          </a>
                      </li>
                  ))} */}
                  {/* Show only current page */}
                  <li key={currentPage} className="page-item active">
                    <a className='page-link' href='#'>                            
                      {currentPage} / {numberOfPages}
                    </a>
                  </li>
                  <li className="page-item">
                      <a className="page-link" 
                          onClick={nextPage}
                          href='#'>                        
                          Next
                      </a>
                  </li>
              </ul>
            }
        </Nav>
  );
}

export default Pagination